import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const BlogComponent = React.lazy(() => import("../Components/RootComponents/BlogComponent"));
const BlogPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <BlogComponent />
      </Suspense>
    </Fragment>
  );
};

export default BlogPage;
